module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_moere_og_romsdal_pos.69af6bc1.svg";